<textarea class="freeText" [(ngModel)]="answer" (change)="answerChanged()"></textarea>
<div *ngIf="jobDataService.trade.id == tradeTypes.Locksmith" 
class="jobTypeContainer greyBox buttonPointer handymanButton" (click)="toggleLocksmithPopup(true)">
    Click here to see common Locksmith jobs
</div>
<div *ngIf="jobDataService.trade.id == tradeTypes.HVAC && jobDataService.jobTypes[currentJobTypeIndex].id == 50"
class="jobTypeContainer greyBox buttonPointer handymanButton" (click)="togglecommonHVACMaintenaceJobsPopup(true)">
    Click here to see tasks carried out during the Maintenance Service
</div>
<div *ngIf="jobDataService.trade.id == tradeTypes.HVAC && jobDataService.jobTypes[currentJobTypeIndex].id == 51"
class="jobTypeContainer greyBox buttonPointer handymanButton" (click)="togglecommonHVACRepairJobsPopup(true)">
    Click here to see common Heating / Cooling Repair jobs
</div>
<div *ngIf="jobDataService.trade.id == tradeTypes.AAHealthyHomeInspection"
class="jobTypeContainer greyBox buttonPointer handymanButton" (click)="toggleHealthyHomesInfoPopup(true)">
    Click here to find out what is included in the Healthy Home Inspection
</div>